module.exports = __webpack_public_path__ + "static/ru-3-7f668844b3db71721af08d83ca2738f1.png";